import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrapiSyncContextService } from '../brapi-sync-context.service';
import { BrapiSyncPath, BrapiSyncService } from '../brapi-sync.service';

@Component({
    selector: 'app-entity-selector',
    templateUrl: './entity-selector.component.html',
    styleUrls: ['./entity-selector.component.css']
})
export class EntitySelectorComponent implements OnInit {

    ENTITY_GERMPLASM = 'germplasm';
    ENTITY_STUDY = 'study';
    ENTITY_OBSERVATION = 'observation';

    entitySelected: string = this.ENTITY_GERMPLASM;
    loading = false;

    constructor(private router: Router,
                public context: BrapiSyncContextService,
                private brapiSyncService: BrapiSyncService) {
    }

    ngOnInit(): void {
        this.context.reset();
    }

    async next(): Promise<void> {
        if (this.entitySelected === this.ENTITY_GERMPLASM) {
            this.brapiSyncService.navigateToPage(BrapiSyncPath.Germplasm);
        } else if (this.entitySelected === this.ENTITY_OBSERVATION) {
            this.brapiSyncService.navigateToPage(BrapiSyncPath.Variable);
        } else if (this.entitySelected === this.ENTITY_STUDY) {
            this.brapiSyncService.navigateToPage(BrapiSyncPath.Trial);
        }
    }

    back(): void {
        this.brapiSyncService.navigateToPage(BrapiSyncPath.Program);
    }

}
